
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/safe-app",
      function () {
        return require("private-next-pages/share/safe-app.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/safe-app"])
      });
    }
  